<template>
  <el-dialog class="dialog-form" :title="id ? '编辑计划' : '新增计划'" :visible.sync="dialogVisible" width="700px"
    :close-on-click-modal="false" :before-close='goBack'>
    <el-form class="global-form2" :model="info" ref="info" :rules="rules" label-width="150px">
      <el-form-item label="计划类型" prop="planType">
        <el-radio v-model="info.planType" :disabled="id != ''" label="1" @change="change">定时计划</el-radio>
        <el-radio v-model="info.planType" :disabled="id != ''" label="2" @change="change">智能计划</el-radio>
      </el-form-item>
      <el-form-item label="计划名称" prop="planName">
        <el-input v-model="info.planName" placeholder="请输入计划名称" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="喷灌区域" prop="areaId">
        <el-select v-model="info.areaId" filterable placeholder="请选择喷灌区域">
          <el-option v-for="(item, index) in areaList" :label="item.areaName" :value="item.areaId"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计划时间段" prop="dateRange">
        <el-date-picker v-model="info.dateRange" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-if="info.planType === '1'" label="喷灌开启时间" prop="executeTime">
        <el-time-select v-model="info.executeTime" :picker-options="{ start: '00:01', step: '00:01', end: '24:00' }"
          placeholder="请选择开启时间到分">
        </el-time-select>
      </el-form-item>

      <el-form-item v-if="info.planType === '2'" label="喷灌启动阈值设置" prop="drought">
        <el-input v-model="info.drought" placeholder="请输入喷灌启动阈值"></el-input>
        <span>&nbsp;%</span>
      </el-form-item>

      <el-form-item label="并发数" prop="concurrentNum">
        <el-input v-model="info.concurrentNum" placeholder="请输入电磁阀一次同时开启的个数，范围1个到3个"
          onkeyup="value=['1','2','3'].indexOf(value) < 0 ? '': value "></el-input>
        <span>&nbsp;个</span>
      </el-form-item>
      <el-form-item v-if="info.planType === '1'" label="喷灌频率:" prop="intervalDays">
        <span>每&nbsp;</span>
        <el-input v-model="info.intervalDays" placeholder="请输入喷灌频率" maxlength="50"></el-input>
        <span>&nbsp;天开启一次喷灌</span>
      </el-form-item>
      <el-form-item label="时长" prop="keepLength">
        <el-input v-model="info.keepLength" placeholder="请输入电磁阀开启时长，时长范围2分钟到99分钟"></el-input>
        <span>&nbsp;分钟</span>
      </el-form-item>
      <el-form-item label="说明">
        <el-input v-if="info.planType === '1'" type="textarea" :rows="3" v-model="timeIrrigationDesc"
          disabled></el-input>
        <el-input v-if="info.planType === '2'" type="textarea" :rows="3" v-model="intellectIrrigationDesc"
          disabled></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" :disabled="submitShow">保存</el-button>
        <el-button @click="goBack">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { pInteger } from '@/utils/validate'
import { timeIrrigationDesc, intellectIrrigationDesc } from '@/utils/config'

const droughtRules = function (rule, value, callback) {
  const reg = /^([1-9][0-9]*|[0-9])(\.\d)?$/
  if (value && !reg.test(value)) {
    return callback(new Error('请输入一位以内的小数或正整数'))
  } else if (Number(value) > 100) {
    return callback(new Error('请输入小于等于100的数字'))
  } else {
    return callback()
  }
}

const numLessTen = function (rule, value, callback) {
  const reg = /^[1-9][0-9]*$/
  if (!reg.test(value) || Number(value) < 2 || Number(value) > 99) {
    return callback(new Error('请输入2到99数值'))
  } else {
    return callback()
  }
}

export default {
  name: 'IrrigationPlanAdd',
  props: {
    showDialog: {
      type: Boolean
    },
    id: String
  },
  data () {
    return {
      dialogVisible: false,
      // 正整数校验，小于10

      info: {
        planType: '1',
        planName: '',
        areaId: '',
        projectId: '',
        dateRange: [],
        executeTime: '',

        concurrentNum: '',
        intervalDays: '',
        keepLength: '',
        drought: ''
      },

      rules: {
        planName: [
          { required: true, message: '请输入计划名称', trigger: ['blur', 'change'] }
        ],
        areaId: [
          { required: true, message: '请选择喷灌区域', trigger: ['blur', 'change'] }
        ],
        dateRange: [
          { required: true, message: '请选择计划时间段', trigger: ['blur', 'change'] }
        ],
        executeTime: [
          { required: true, message: '请选择开启时间', trigger: ['blur', 'change'] }
        ],
        concurrentNum: [
          { required: true, message: '请输入电磁阀一次同时开启的个数，范围1个到3个', trigger: ['blur', 'change'] }
        ],
        intervalDays: [
          { required: true, message: '请输入喷灌频率', trigger: ['blur', 'change'] },
          { validator: pInteger, trigger: ['blur', 'change'] }
        ],
        keepLength: [
          { required: true, message: '请输入电磁阀开启时长，时长范围2分钟到99分钟', trigger: ['blur', 'change'] },
          { validator: numLessTen, trigger: ['blur', 'change'] }
        ],
        drought: [
          { required: true, message: '请输入喷灌启动阈值', trigger: ['blur'] },
          { validator: droughtRules, trigger: ['blur', 'change'] }
        ]
      },

      areaList: [],
      submitShow: false
    }
  },
  computed: {
    timeIrrigationDesc () {
      return timeIrrigationDesc
    },
    intellectIrrigationDesc () {
      return intellectIrrigationDesc
    },
    projectId () {
      return this.$route.query.projectId
    }

  },
  watch: {
    showDialog (val) {
      this.dialogVisible = val
    },
    id (val) {
      if (val) {
        this.getPlanDetail(val)
      }
    }
  },

  created () {
    this.getArea()
  },
  methods: {
    // 清空状态和数值
    change (val) {
      this.$refs.info.resetFields()
      this.info.planType = val
    },

    getPlanDetail (id) {
      this.$axios.get(this.$apis.irrigation.selectIrrigationPlanByPlanId, {
        planId: id
      }).then((res) => {
        this.change(res.planType)
        this.info = {
          planType: res.planType,
          planId: res.planId,
          planName: res.planName,
          areaId: res.areaId,
          projectId: res.projectId,
          dateRange: [res.startDate, res.endDate],
          executeTime: res.executeTime,
          drought: res.drought,
          concurrentNum: res.concurrentNum,
          intervalDays: res.intervalDays,
          keepLength: res.keepLength
        }
      })
    },

    getArea () {
      this.$axios.get(this.$apis.irrigation.selectIrrigationAreaByPage, {
        projectId: this.projectId
      }).then((res) => {
        this.areaList = res.list || []
      })
    },

    onSubmit () {
      this.$refs.info.validate((valid) => {
        if (valid) {
          this.submitShow = true
          const info = {
            projectId: this.$route.query.projectId,
            planName: this.info.planName,
            areaId: this.info.areaId,
            planType: this.info.planType,
            startDate: this.info.dateRange[0],
            endDate: this.info.dateRange[1],
            executeTime: this.info.executeTime,
            concurrentNum: this.info.concurrentNum,
            intervalDays: this.info.intervalDays,
            keepLength: this.info.keepLength,
            planId: this.info.planId,
            drought: this.info.drought
          }
          const url = this.id ? this.$apis.irrigation.updateIrrigationPlan : this.$apis.irrigation.insertIrrigationPlan
          this.$axios.post(url, {
            ...info
          }).then(() => {
            this.$message({ message: '保存成功', type: 'success' })
            this.goBack()
          }).finally(() => {
            this.submitShow = false
          })
        }
      })
    },

    goBack () {
      this.info = {
        planType: '1',
        planName: '',
        areaId: '',
        projectId: '',
        dateRange: [],
        executeTime: '',
        concurrentNum: '',
        intervalDays: '',
        keepLength: '',
        drought: ''
      }
      this.$nextTick(() => {
        this.$refs.info.clearValidate()
      })
      this.$emit('update:showDialog', false)
      this.$emit('success')
    }
  }

}
</script>

<style scoped lang="scss">
.tips-box {
  display: flex;
  align-items: center;
  color: #ccc;

  .num {
    color: red;
  }
}
</style>
